export default "__VITE_ASSET__Bq_3OIsU__"